module.exports = __webpack_public_path__ + "static/img/user-bg.0e328f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/user-bg.png
// module id = knbw
// module chunks = 2